<template lang="pug">
  div.st-FlashReport_Icon_User(:style="`background-image: url('${image}')`")
</template>
<script>
  export default {
    props: {
      image: { type: String, default: '' },
    },
  };
</script>
